export default __webpack_public_path__ + "static/media/Logo.e9b73ea7.png";